import { render, staticRenderFns } from "./KanXin.vue?vue&type=template&id=4d84746c&"
import script from "./KanXin.vue?vue&type=script&lang=js&"
export * from "./KanXin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports